import type {
  BrandId,
  BrokerId,
  CustomerId,
  LeadId,
  MaaiStage,
  OrderId,
  ProductId,
  TicketId,
} from "./types";

type SimulatedMeta = {
  simulated: true;
  networkCall: false;
};

export type DomainEvent =
  | ({ type: "order.maai1.created"; orderId: OrderId; customerId: CustomerId; productId: ProductId; brokerId: BrokerId | null; amount: number; at: number } & SimulatedMeta)
  | ({ type: "lead.assigned"; leadId: LeadId; agent: string; at: number } & SimulatedMeta)
  | ({ type: "order.maai2.closed"; orderId: OrderId; leadId: LeadId; amount: number; useHouseBrand: boolean; at: number } & SimulatedMeta)
  | ({ type: "lead.rejected"; leadId: LeadId; reason: string; at: number } & SimulatedMeta)
  | ({ type: "order.maai3plus.detected"; orderId: OrderId; previousOrderIds: OrderId[]; maai: Extract<MaaiStage, 3 | 4>; at: number } & SimulatedMeta)
  | ({ type: "broker.withdraw"; brokerId: BrokerId; amount: number; at: number } & SimulatedMeta)
  | ({ type: "supplier.withdraw"; brandId: BrandId; amount: number; at: number } & SimulatedMeta)
  | ({ type: "settlement.paid"; settlementId: string; at: number } & SimulatedMeta)
  | ({ type: "ticket.replied"; ticketId: TicketId; from: string; at: number } & SimulatedMeta)
  | ({ type: "ticket.closed"; ticketId: TicketId; at: number } & SimulatedMeta)
  | ({ type: "brand.approved"; brandId: BrandId; at: number } & SimulatedMeta)
  | ({ type: "coupon.added"; couponId: string; code: string; at: number } & SimulatedMeta)
  | ({ type: "campaign.added"; campaignId: string; name: string; at: number } & SimulatedMeta)
  | ({ type: "push.sent"; title: string; reach: number; at: number } & SimulatedMeta);

export type EventLogEntry = DomainEvent & { id: string };

export type EventInput = DomainEvent extends infer Event
  ? Event extends DomainEvent
    ? Omit<Event, "simulated" | "networkCall">
    : never
  : never;

export function withEventMeta(id: string, event: EventInput): EventLogEntry {
  return {
    ...event,
    id,
    simulated: true,
    networkCall: false,
  } as EventLogEntry;
}
